import { styled } from '../../base-components';
import { Box } from '../../base-components';

export const ChipInputWrapper = styled(Box)(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
    alignItems: 'center',
    width: '100%',
}));
